import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import ConfirmModal from '@sdk/components/ui/confirmModal/ConfirmModal';
import TextInputBase from '@sdk/components/forms/TextInputBase';
import FieldError from '@sdk/components/forms/components/FieldError';
import gettext, { pgettext } from '@sdk/lang/gettext';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import {
  IconWrapper,
  Label,
} from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalFooter/DenyButton/denyButton.styles';
import { useDenyButton } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalFooter/DenyButton/denyButton.hooks';
import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';

type Props = {
  deny: (reason: string) => Promise<void>;
};

const DenyButton = ({ deny }: Props) => {
  const { isVisible, reasonField, isInvalidReason, openDenyModal, onDismiss, onDeny } =
    useDenyButton(deny);

  return (
    <>
      <ProgressButton buttonType={ButtonType.danger} onClick={openDenyModal}>
        {gettext('Deny')}
      </ProgressButton>
      {isVisible && (
        <ConfirmModal
          buttonsPadding={0}
          dismissOnBackdropClick={false}
          fullScreen
          titleText={pgettext(
            'Confirm modal title, visible when providing reason for denial of timesheet changes',
            'Please specify'
          )}
          titleIcon={
            <IconWrapper>
              <ExclamationMarkIcon aria-hidden={true} />
            </IconWrapper>
          }
          primaryButtonText={gettext('Submit')}
          primaryButtonType={ButtonType.danger}
          primaryButtonDisabled={!reasonField.dirty || isInvalidReason}
          secondaryButtonText={gettext('Back')}
          dismiss={onDismiss}
          onPrimaryClick={onDeny}
          zIndex={1045}>
          <Label htmlFor="deny-timesheet-changes-reason">
            {gettext('Please specify a reason for denying the timesheet edits:')}
          </Label>

          <TextInputBase
            id="deny-timesheet-changes-reason"
            maxLength={160}
            name="reason"
            onChange={reasonField.onChange}
            onBlur={reasonField.onBlur}
            placeholder={gettext('Add a reason')}
            type="text"
            value={reasonField.value}
            invalid={isInvalidReason}
          />
          <FieldError invalid={isInvalidReason} error={reasonField.error} />
        </ConfirmModal>
      )}
    </>
  );
};

export default DenyButton;
